import DeltaWifiEditorialCard from './DeltaWifiEditorialCard';

export default DeltaWifiEditorialCard;
